import { _ } from "libs";

import React from "react";
import ReservationItemSmall from "../items/reservation/small";
import { ReservationActivity } from "../../types";
import { prettyDate } from "../../actions/prettyDate";
import { formatName } from "../../libs/formatName";
import { openPlayerPopup } from "../../actions";

const Reservations = ({ activities, userId }: { activities: ReservationActivity[]; userId: string }) => {
	const filteredActivities = activities.filter(activity => activity.actor.data.userId !== userId);

	if (filteredActivities.length === 0) {
		return null;
	}

	return (
		<div className="nBlock fixedHeader">
			<h5>{_("timeline.buddiesReservations.heading")}</h5>
			<div className="newsFeedReservations">
				{filteredActivities.map((activity, index) => {
					return (
						<div
							className="clickable"
							onClick={() => openPlayerPopup(activity.actor.data.userId)}
							key={index}
						>
							<ReservationItemSmall
								name={formatName(activity.actor.data.firstName, activity.actor.data.lastName)}
								photoUrl={activity.actor.data.photoUrl}
								club={activity.reservation.club.clubInfo.name}
								date={prettyDate(activity.reservation.startDateTime)}
								extra="smallBox"
							/>
						</div>
					);
				})}
				<div className="lastReservationPaddingFix">&nbsp;</div>
			</div>
		</div>
	);
};

export default Reservations;
